import type { OptionsType, SelectProps } from '@atlaskit/select';

function isArray<T>(arg: unknown): arg is readonly T[] {
	return Array.isArray(arg);
}

export const cleanValue = <Option>(value: SelectProps<Option>['value']): OptionsType<Option> => {
	if (isArray(value)) {
		return value.filter(Boolean);
	}

	if (typeof value === 'object' && value !== null) {
		return [value];
	}

	return [];
};
